// extracted by mini-css-extract-plugin
module.exports = {"item":"c030","image":"_6717","title":"_7170"};